import * as React from "react";
import { useState, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "components/common/MenuItem";
import { ListItemText, Select, InputLabel } from "@mui/material";
import Text from "components/common/Text";

export default function DialogEditVehicleModel({
  open,
  handleClose,
  selectlist,
  handleOnChange,
  modle_name,
  year,
  manufacturer_id,
  editfile,
  handleClickSubmit,
  handleOnChangeEditFile,
  thumbnail
}) {
  const image = useRef();

  const [errors, setErrors] = useState({
    modle_name: "",
    year: "",
  });

  const handleSubmit = () => {
    const editVehicleErrors = {};
    if (!modle_name) {
      editVehicleErrors.modle_name = "Vehicle Model Name is required.";
    }
    if (!year) {
      editVehicleErrors.year = "Vehicle Model Year is required.";
    }
    
    setErrors(editVehicleErrors);

    if (!editVehicleErrors.modle_name && !editVehicleErrors.year) {
      handleClickSubmit();
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit Vehicle model name"}
        </DialogTitle>
        <DialogContent>
          <InputLabel id="demo-simple-select-label" sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Select Vehicle Manufacturer
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            defaultValue={manufacturer_id}
            label="Age"
            sx={{
              margin: "0 0 10px 0",
              width: "100%",
              height: "44px",
              background: "#FFFFFF",
              border: "1px solid #EBEBEB",
              borderRadius: "6px",
            }}
            onChange={(e) => {
              handleOnChange(e, "manufacturer_id");
            }}
          >
            {selectlist?.map((item) => (
              <MenuItem key={item} value={item.id}>
                <ListItemText primary={item.name}/>
              </MenuItem>
            ))}
          </Select>
          <InputLabel id="demo-simple-select-label" sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Enter Vehicle Model Name
          </InputLabel>
          <DialogContentText>
            <input
              placeholder="Enter vehicle model name"
              style={{
                margin: "0 0 10px 0",
                width: "92%",
                padding: '0px 13px',
                height: "44px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
                fontSize:'17px'
              }}
              defaultValue={modle_name}
              onChange={(e) => {
                handleOnChange(e, "modle_name");
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^a-zA-Z^0-9 ]*/g, "");
              }}
            />
            {errors.modle_name && (
              <Text sx={{ fontSize: "14px", color: "red",marginBottom:'3px' }}>{errors.modle_name}</Text>
            )}
          </DialogContentText>

          <InputLabel id="demo-simple-select-label" sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Enter Vehicle Model Year
          </InputLabel>
          <input
            placeholder="Enter vehicle model Year"
            style={{
              margin: "0 0 10px 0",
              width: "92%",
              padding: '0px 13px',
              height: "44px",
              background: "#FFFFFF",
              border: "1px solid #EBEBEB",
              borderRadius: "6px",
              fontSize:'17px'
            }}
            defaultValue={year}
            onChange={(e) => {
              handleOnChange(e, "year");
            }}
            onInput={(e) => {
              e.target.value = e.target.value
                .trimStart()
                .replace(/[^0-9]/g, "");
            }}
            minlength="4"
            maxlength="4"
          />
          {errors.year && (
            <Text sx={{ fontSize: "14px", color: "red",marginBottom:'3px' }}>{errors.year}</Text>
          )}

          <InputLabel id="demo-simple-select-label" sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Edit Vehicle model image
          </InputLabel>

          <div style={{display:'flex',gap:'10px'}}>
              <img
                  src={thumbnail}
                  alt="Vehicle"
                  style={{ width: "70px"}}
                />
              <input
                ref={image}
                type="file"
                accept="image/*"
                placeholder="Enter vehicle model Year"
                style={{
                  height: '32px',
                  padding: '13px 10px 0px',
                  background: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                  borderRadius: "6px",
                }}
                onChange={(e) => {
                  handleOnChangeEditFile(e.currentTarget.files[0]);
                }}
                />
          </div>

          {editfile.error ? (
            <Text sx={{ fontSize: "14px", color: "red" }}>{editfile.message}</Text>
          ) : null}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100px",
              height: "40px",
              marginBottom: "1rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            onClick={handleSubmit}
            disabled={!modle_name && !year && !editfile}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
